export default __webpack_public_path__ + "static/media/Ellipse 111 (3).6732967e.png";